import ReviewTextTopic from '@app/model/review/ReviewTextTopic';
import ReviewTextType from '@app/model/review/ReviewTextType';


export class ReviewText {
	id: number;
	creationDate: string
	type: ReviewTextType
	language: string
	text: string
	translation: string
	topics: ReviewTextTopic[]

	constructor(data: ReviewText) {
		Object.assign(this, data);
	}

	public getTopics() {
		return this.topics || [];
	}
}